/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Toggle_Visibility_Aria_LabelInputs */

const en_style_guide_manager_toggle_visibility_aria_label = /** @type {(inputs: Style_Guide_Manager_Toggle_Visibility_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle guide visibility`)
};

const fr_style_guide_manager_toggle_visibility_aria_label = /** @type {(inputs: Style_Guide_Manager_Toggle_Visibility_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basculer la visibilite du guide`)
};

const de_style_guide_manager_toggle_visibility_aria_label = /** @type {(inputs: Style_Guide_Manager_Toggle_Visibility_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leitfaden-Sichtbarkeit umschalten`)
};

const it_style_guide_manager_toggle_visibility_aria_label = /** @type {(inputs: Style_Guide_Manager_Toggle_Visibility_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva/disattiva la visibilità della guida`)
};

const ru_style_guide_manager_toggle_visibility_aria_label = /** @type {(inputs: Style_Guide_Manager_Toggle_Visibility_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключить видимость руководства`)
};

const es_style_guide_manager_toggle_visibility_aria_label = /** @type {(inputs: Style_Guide_Manager_Toggle_Visibility_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activar o desactivar la visibilidad de la guía`)
};

const zh_cn2_style_guide_manager_toggle_visibility_aria_label = /** @type {(inputs: Style_Guide_Manager_Toggle_Visibility_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换指南可见性`)
};

const ja_style_guide_manager_toggle_visibility_aria_label = /** @type {(inputs: Style_Guide_Manager_Toggle_Visibility_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ガイドの表示を切り替える`)
};

const hi_style_guide_manager_toggle_visibility_aria_label = /** @type {(inputs: Style_Guide_Manager_Toggle_Visibility_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गाइड की दृश्यता को टॉगल करें`)
};

const pt_pt2_style_guide_manager_toggle_visibility_aria_label = /** @type {(inputs: Style_Guide_Manager_Toggle_Visibility_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar visibilidade do guia`)
};

/**
* | output |
* | --- |
* | "Toggle guide visibility" |
*
* @param {Style_Guide_Manager_Toggle_Visibility_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_toggle_visibility_aria_label = /** @type {((inputs?: Style_Guide_Manager_Toggle_Visibility_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Toggle_Visibility_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_toggle_visibility_aria_label(inputs)
	if (locale === "de") return de_style_guide_manager_toggle_visibility_aria_label(inputs)
	if (locale === "it") return it_style_guide_manager_toggle_visibility_aria_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_toggle_visibility_aria_label(inputs)
	if (locale === "es") return es_style_guide_manager_toggle_visibility_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_toggle_visibility_aria_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_toggle_visibility_aria_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_toggle_visibility_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_toggle_visibility_aria_label(inputs)
	return en_style_guide_manager_toggle_visibility_aria_label(inputs)
});